/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const incentivesDataSlice = createSlice({
	name: 'incentivesData',
	initialState,
	reducers: {
		setIncentivesData(state, action) {
			return action.payload;
		}
	}
});

export const { setIncentivesData } = incentivesDataSlice.actions;

export default incentivesDataSlice.reducer;
